export default __webpack_public_path__ + "static/media/FellowshipDesktopBorderMobile.8bd96f79.svg";